import graphql__d248280a5904ed9da2b4 from "./__generated__/ContributionsDatavizTabs_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useRoutesContext } from "../../../Routes/RoutesContext";
import { useFormatMessage } from "../../../Intl/Context";
import ButtonLink from "../../../Buttons/ButtonLink";

const ContributionsDatavizTabs = ({
  exploreTabActive = false,
  searchTabActive = false,
  ...props
}) => {
  const participativeModule = useFragment(
    ContributionsDatavizTabs_participativeModule,
    props.participativeModule
  );
  const t = useFormatMessage();
  const contributionsMapLabel = t(intlMessages.contributionsMap);
  const contributionsSearchLabel = t(intlMessages.contributionsSearch);

  const { slug: participativeModuleSlug, visualization } = participativeModule;

  const firstPageVisualizationType = visualization.enableListViewOnFirstPage
    ? "datavizList"
    : "datavizGraph";

  const { pathFor } = useRoutesContext();
  const graphPath = pathFor(firstPageVisualizationType, { participativeModuleSlug });
  const searchPath = pathFor("datavizSearch", { participativeModuleSlug });

  const commonClassNames = ["nav-link", "text-uppercase"];
  // Since activeClassNames are used a single object key in the classNames() arguments
  // list, we join them to make them a string instead of an array to make them active
  // in the right conditions.
  const activeClassNames = [
    "active",
    "border-0",
    "border-radius-none",
    "text-primary",
    "text-primary-hover",
    "border-primary"
  ].join(" ");

  const graphTabClassName = classNames(commonClassNames, {
    [activeClassNames]: exploreTabActive
  });

  const searchTabClassName = classNames([
    ...commonClassNames,
    { [activeClassNames]: searchTabActive }
  ]);

  return (
    <ul className="nav nav-tabs margin-y-xs">
      <div className="d-flex flex-row flex-lg-row justify-content-center justify-content-lg-start">
        <li className="nav-item">
          <ButtonLink
            id="dataviz-tabs-graph-link"
            className={graphTabClassName}
            href={graphPath}
            label={contributionsMapLabel}
            aria-current={exploreTabActive && "page"}
            aria-pressed={exploreTabActive && "true"}
            role="button"
          />
        </li>
        <li className="nav-item">
          <ButtonLink
            id="dataviz-tabs-search-link"
            className={searchTabClassName}
            href={searchPath}
            label={contributionsSearchLabel}
            aria-current={searchTabActive && "page"}
            aria-pressed={searchTabActive && "true"}
            role="button"
          />
        </li>
      </div>
    </ul>
  );
};

const ContributionsDatavizTabs_participativeModule = graphql__d248280a5904ed9da2b4;

export default ContributionsDatavizTabs;

const intlMessages = defineMessages({
  contributionsMap: {
    id: "contributions.dataviz.navigation.contributionsMap",
    defaultMessage: "Carte des contributions"
  },
  contributionsSearch: {
    id: "contributions.dataviz.navigation.contributionsSearch",
    defaultMessage: "Rechercher des contributions"
  }
});
